import axios from 'axios';

const loadItems = (options, obj) => {
  axios.get('/financial/refund-note/customers/', {
    params: obj,
  }).then(response => {
    options.commit('SET_ITEMS', response.data);
  });
};

const addItem = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('obj', JSON.stringify(obj));
  axios.post('/financial/refund-notes/add/', bodyFormData).then(response => {
    options.commit('ADD_ITEM', response.data);
  });
};

const editItem = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('obj', JSON.stringify(obj));
  axios
    .post('/financial/refund-notes/' + obj.pk + '/edit/', bodyFormData)
    .then(response => {
      options.commit('EDIT_ITEM', response.data);
    });
};

const deleteItem = (options, obj) => {
  axios.post('/financial/refund-notes/' + obj.pk + '/delete/').then(() => {
    options.commit('DELETE_ITEM', obj);
  });
};

export default { loadItems, addItem, editItem, deleteItem };
